import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { EDIT_TEAM, LISTE_EQUIPE_PRESTATAIRE } from "../../Utils/constant";
import { updateOne } from "../../services/service";
import { useEquipeStore } from "../../store/EquipeStore";
export const UpdateTeam = ({ item }) => {
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [select, setSelect] = useState([]);
  const equipe = useEquipeStore();
  const submit = (data) => {
    console.log(select);
    setIsSubmit(true);
    updateOne(EDIT_TEAM, item?.id, data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          equipe.getEquipePrestataire(
            LISTE_EQUIPE_PRESTATAIRE + "/" + id,
            { page: 0, param: 0, size: 10 },
            ""
          );
          document.getElementById("close").click();
          reset();
          toast.success("Designation modifiée");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit(submit)} className="px-2">
        <div className="my-4 space-y-4">
          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Nom de l'equipe
            </label>
            <input
              defaultValue={item?.equipe?.designation}
              type="text"
              placeholder="nom de l'equipe"
              className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
              {...register("libelle", { required: true })}
            />
            {errors.libelle && (
              <span className="text-sm text-rose-600">
                Ce champs est obligatoire
              </span>
            )}
          </div>

          <button
            type="submit"
            disabled={isSubmit ? true : false}
            className={`${
              !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
          >
            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </>
  );
};
